import VuexErrors from 'src/vuex/modules/errors'

export default {
  namespaced: true,

  state () {
    return {
      defaultLanguage: 'en',
      defaultIso: 'US',
      updateDelay: 500,
      gridCols: 12
    }
  },

  getters: {
    language: state => {
      return state.defaultLanguage
    },
    iso: state => {
      return state.defaultIso
    },
    updateDelay: state => {
      return state.updateDelay
    },
    gridCols: state => {
      return state.gridCols
    }
  },

  modules: {
    errors: VuexErrors
  }
}
